<ng-template #newExerciseTemplate>
	<mod-exercise-form (create)="handleCreateExercise($event)" [isInDialog]="true"></mod-exercise-form>
</ng-template>

<ng-template #noExercisesMessage>
	<lib-message [type]="'noDataOnBody'">There are no exercises in this workout.</lib-message>
</ng-template>

<ng-template #editSessionTemplate>
	@if (sessionEditUserItem(); as sessionEditUserItem) { @if (selectedSessionItem(); as selectedSessionItem) {
	<mod-edit-session
		[isInDialog]="true"
		[editMode]="'limited'"
		[userItem]="sessionEditUserItem"
		[sessionItem]="selectedSessionItem"
	></mod-edit-session>
	} }
</ng-template>

@if (workout(); as workout) {
<div>
	<!-- View -->
	@if (isEdit() === false) { @if (viewMainButtons(); as viewMainButtons) { @if (viewMainButtons.length) {
	<div class="push-bottom">
		<lib-button-list [buttons]="viewMainButtons"></lib-button-list>
	</div>
	} }

	<!-- Notes-->
	@if (workout.notes) {
	<lib-message class="push-bottom" [type]="'info'" [title]="'Workout notes'">
		<div [innerHTML]="workout.notes | textToHtml"></div>
	</lib-message>
	}

	<!-- Details table -->
	@if (workoutDetailsSimpleTableItems(); as workoutDetailsSimpleTableItems) {
	<lib-card class="push-bottom" [titleSize]="'h3'" [addContentDivider]="false" [isCollapsible]="false">
		<ui-simple-table
			[items]="workoutDetailsSimpleTableItems"
			[columnsPerRow]="1"
			[hideEmptyItems]="true"
		></ui-simple-table>
	</lib-card>
	} @if (extendedWorkoutExerciseContainers(); as workoutExerciseContainers) { @if (workoutExerciseContainers?.length)
	{

	<div class="push-bottom">
		<lib-divider [layout]="'withContent'" [color]="'onBody'"
			><div litText2>{{ exercisesDividerTitle() }}</div></lib-divider
		>
	</div>

	<div>
		@for ( exerciseContainer of workoutExerciseContainers; track exerciseContainer.originalContainer.id; let
		containerIndex = $index; let firstContainer = $first; let lastContainer = $last) {
		<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'" [class.push-top]="!firstContainer">
			<div libFlexColumn libText4>{{ containerIndex + 1 }})</div>
			<div libFlexColumn libFlexFill>
				<div libText3>{{ exerciseContainer.title }}</div>
			</div>
			<div libFlexColumn>
				<lib-button-list [buttons]="exerciseContainer.buttons" [mode]="'single'"></lib-button-list>
			</div>
		</div>
		<div class="w-anchor" [id]="exerciseContainer.domId"></div>
		<div>
			@if (exerciseContainer.variantSelectionItems.length > 1) {
			<div class="push-top-sm" libFlexRow>
				<div libFlexColumn libFlexFill>
					<ui-select-item-field
						[placeholder]="'Select exercise...'"
						[design]="'card'"
						[items]="exerciseContainer.variantSelectionItems"
						[valueAsSignal]="exerciseContainer.activeExercise?.idAsSignal"
						(valueChange)="handleSetActiveExercise(exerciseContainer, $event)"
					></ui-select-item-field>
				</div>
			</div>
			} @if (exerciseContainer.activeExercise) {
			<lib-card
				class="push-top-sm"
				[titleSize]="'h3'"
				[roundCardImages]="false"
				[title]="exerciseContainer.activeExercise.name"
				[subtitle]="exerciseContainer.activeExercise.subtitle"
				[buttons]="exerciseContainer.activeExercise.buttons"
				[buttonsExtendedListThreshold]="1"
				[imagesLocation]="'default'"
			>
				<!-- Exercise video / images & info-->
				<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
					@if (exerciseContainer.activeExercise.linkedExercise &&
					exerciseContainer.activeExercise.linkedExercise.videoUrl && !isPdfView()) {
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '400px'">
						<lib-video [url]="exerciseContainer.activeExercise.linkedExercise.videoUrl"></lib-video>
					</div>
					} @else if (exerciseContainer.activeExercise.previewImages.length) {
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '400px'">
						<div libFlexRow [libFlexRowGap]="'16px'">
							@for (image of exerciseContainer.activeExercise.previewImages; track
							image.originalImage.absoluteUrl; let index = $index) {
							<div libFlexColumn>
								<lib-image
									[alt]="'Image preview'"
									[imageSize]="'250px'"
									[isResponsive]="true"
									[maxHeight]="150"
									[image]="image"
									[isRound]="false"
									[dialogPreviewImage]="image"
								></lib-image>
							</div>
							}
						</div>
					</div>
					}
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
						@if (exerciseContainer.activeExercise.aboutExerciseInfoTableItems) {
						<ui-info-table
							[hideEmptyItems]="true"
							[items]="exerciseContainer.activeExercise.aboutExerciseInfoTableItems"
						></ui-info-table>
						}
					</div>
				</div>

				<!-- Sets -->
				<ng-template #setsTemplate>
					@if (exerciseContainer.activeExercise.extendedSets.length) {
					<div class="push-top">
						<lib-divider [layout]="'withContent'">
							<div libText3>{{ exerciseContainer.activeExercise.setsTitle }}</div>
						</lib-divider>

						<div class="push-top">
							@for ( set of exerciseContainer.activeExercise.extendedSets; track set.originalSet.id; let
							setIndex = $index; let firstSet = $first) {
							<div libFlexRow [class.push-top-sm]="!firstSet">
								<div libFlexColumn libFlexFill>
									{{ set.textSignal() }}
								</div>
							</div>
							}
						</div>
					</div>
					}
				</ng-template>

				<div>
					<ng-template [ngTemplateOutlet]="setsTemplate"></ng-template>
				</div>
			</lib-card>
			} @for ( exercise of exerciseContainer.exercises; track exercise.id; let firstExercise = $first; let
			lastExercise = $last) {
			<div></div>
			}
		</div>
		}
	</div>
	} @else { @if (workout.type === 'workout') {
	<div class="push-top">
		<ng-template [ngTemplateOutlet]="noExercisesMessage"></ng-template>
	</div>
	} } } }

	<!-- Edit -->
	@if (isEdit() === true) {

	<div>
		<lib-message [type]="'tip'" [dismissId]="'edit-workout-tip'" [className]="'push-bottom'">
			@if (sharedData()?.data?.clientData) {
			<div>
				You are editing client workout. Any changes made here will NOT affect original template from which this
				workout was assigned.
			</div>
			} @else {
			<div>
				You are editing a template. Any changes you make here will NOT affect workouts already assigned to
				clients using this template.
			</div>
			<div class="push-top-sm">Once you assign a template to a client, it becomes independent.</div>
			}
		</lib-message>
	</div>

	<!-- Notes-->
	<lib-message class="push-bottom" [type]="'info'" [title]="'Workout notes'" [button]="editNotesButton()">
		<div [innerHTML]="workout.notes ?? 'n/a' | textToHtml"></div>
	</lib-message>

	@if (workoutDetailsSimpleTableItems(); as workoutDetailsSimpleTableItems) {
	<lib-card class="push-bottom" [titleSize]="'h3'" [addContentDivider]="false" [isCollapsible]="false">
		<ui-simple-table
			[items]="workoutDetailsSimpleTableItems"
			[columnsPerRow]="1"
			[hideEmptyItems]="false"
			[enableDivider]="true"
		></ui-simple-table>
	</lib-card>
	}

	<ng-container>
		@if (editQuickActionButtons(); as editQuickActionButtons) { @if (editQuickActionButtons.length) {
		<lib-card [title]="'Designer actions'" class="push-bottom" [addContentDivider]="true" [enableCard]="false">
			<div>
				<lib-button-list
					[mode]="'extendedList'"
					[useFullSizeButtons]="false"
					[addExtendedListMoreLabel]="false"
					[extendListThreshold]="1"
					[moreIcon]="'settings'"
					[buttons]="editQuickActionButtons"
				></lib-button-list>
			</div>
		</lib-card>
		} }
	</ng-container>

	@if (extendedWorkoutExerciseContainers(); as workoutExerciseContainers) { @if (workoutExerciseContainers?.length) {
	<div>
		@for ( exerciseContainer of workoutExerciseContainers; track exerciseContainer.originalContainer.id; let
		containerIndex = $index; let firstContainer = $first; let lastContainer = $last) {
		<div class="w-anchor" [id]="exerciseContainer.domId"></div>
		<div [class.push-top]="!firstContainer">
			<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
				<div libFlexColumn libText4>{{ containerIndex + 1 }})</div>
				<div libFlexColumn libFlexFill>
					@if (exerciseContainer.title) {
					<div libText3>{{ exerciseContainer.title }}</div>
					}
				</div>
				<div libFlexColumn>
					<lib-button-list
						[buttons]="exerciseContainer.buttons"
						[mode]="isMobileView() ? 'list' : 'list'"
						[extendListThreshold]="4"
					></lib-button-list>
				</div>
			</div>
			@if (exerciseContainer.variantSelectionItems.length > 1) {
			<div [libFlexRow]="isMobileView()" [libFlexRowGap]="isMobileView() ? '8px' : '16px'" class="push-top-sm">
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
					<ui-select-item-field
						[placeholder]="'Select exercise...'"
						[mode]="'tooltipMenu'"
						[design]="'card'"
						[items]="exerciseContainer.variantSelectionItems"
						[valueAsSignal]="exerciseContainer.activeExercise?.idAsSignal"
						(valueChange)="handleSetActiveExercise(exerciseContainer, $event)"
					></ui-select-item-field>
				</div>
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '220px'">
					<ui-select-item-field
						[mode]="'tooltipMenu'"
						[design]="'card'"
						[placeholder]="'Select type...'"
						[items]="exerciseTypeSelectionItems"
						[valueAsSignal]="exerciseContainer.typeSignal"
						(valueChange)="handleSetExerciseType(exerciseContainer, $event)"
					></ui-select-item-field>
				</div>
			</div>
			} @if (exerciseContainer.activeExercise) {
			<lib-card
				class="push-top-sm"
				[titleSize]="'h3'"
				[title]="exerciseContainer.activeExercise.name"
				[subtitle]="exerciseContainer.activeExercise.subtitle"
				[buttons]="exerciseContainer.activeExercise.buttons"
				[buttonsMode]="isMobileView() ? 'single' : 'extendedList'"
				[buttonsExtendedListThreshold]="
					getExerciseContainerButtonThreshold(firstContainer, lastContainer, workoutExerciseContainers.length)
				"
				[imagesLocation]="'default'"
				[roundCardImages]="false"
			>
				<ng-template #setsTemplate>
					@if (exerciseContainer.activeExercise.extendedSets.length) {
					<div>
						@for ( set of exerciseContainer.activeExercise.extendedSets; track set.originalSet; let setIndex
						= $index; let firstSet = $first) {
						<div libFlexRow [libFlexRowGap]="'8px'" [class.push-top-sm]="!firstSet">
							<div libFlexColumn libFlexFill>
								<ui-text-form-field
									[placeholder]="'Set ' + (setIndex + 1) + ' ...'"
									[isRequired]="true"
									[useDebounce]="true"
									[maxLength]="setMaxLength"
									[valueAsSignal]="set.textSignal"
									(valueChange)="handleSetChanged($event, exerciseContainer.activeExercise, set)"
									(fastInputChange)="
										handleFastSetChanged($event, exerciseContainer.activeExercise, set)
									"
								></ui-text-form-field>
							</div>
							<div libFlexColumn>
								<lib-button-list [mode]="'single'" [buttons]="set.buttons"></lib-button-list>
							</div>
						</div>
						}
					</div>
					}
					<div class="push-top" libFlexRow>
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
							<lib-button
								[buttonSize]="'default'"
								[buttonType]="'primaryLight'"
								(click)="handleAddSet(exerciseContainer.activeExercise)"
								>Add set</lib-button
							>
						</div>
					</div>
				</ng-template>

				<!-- Exercise video / images & info-->
				<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
					@if (exerciseContainer.activeExercise.linkedExercise &&
					exerciseContainer.activeExercise.linkedExercise.videoUrl && !isPdfView()) {
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '400px'">
						<lib-video [url]="exerciseContainer.activeExercise.linkedExercise.videoUrl"></lib-video>
					</div>
					} @else if (exerciseContainer.activeExercise.previewImages.length) {
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : '400px'">
						<div libFlexRow [libFlexRowGap]="'16px'">
							@for (image of exerciseContainer.activeExercise.previewImages; track
							image.originalImage.absoluteUrl; let index = $index) {
							<div libFlexColumn>
								<lib-image
									[alt]="'Image preview'"
									[imageSize]="'250px'"
									[isResponsive]="true"
									[maxHeight]="150"
									[image]="image"
									[isRound]="false"
									[dialogPreviewImage]="image"
								></lib-image>
							</div>
							}
						</div>
					</div>
					}
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
						@if (exerciseContainer.activeExercise.aboutExerciseInfoTableItems) {
						<ui-info-table
							[hideEmptyItems]="true"
							[items]="exerciseContainer.activeExercise.aboutExerciseInfoTableItems"
						></ui-info-table>
						}
					</div>
				</div>

				<!-- Sets -->
				<div class="push-top">
					<lib-divider [layout]="'withContent'">
						<div libText3>{{ exerciseContainer.activeExercise.setsTitle }}</div>
					</lib-divider>

					<div class="push-top">
						<ng-template [ngTemplateOutlet]="setsTemplate"></ng-template>
					</div>
				</div>
			</lib-card>
			}
		</div>
		}
	</div>

	@if (addExerciseToBottomButtons(); as addExerciseToBottomButtons) {
	<ng-container>
		@if (addExerciseToBottomButtons.length) {
		<div class="push-top">
			<lib-button-list
				[mode]="isMobileView() ? 'block' : 'list'"
				[useFullSizeButtons]="isMobileView()"
				[buttons]="addExerciseToBottomButtons"
			></lib-button-list>
		</div>
		} </ng-container
	>} } @else {
	<div class="push-top">
		<ng-template [ngTemplateOutlet]="noExercisesMessage"></ng-template>
	</div>
	} } }
</div>
}
